// Mock data for Pires Advogados - Restituição ITBI landing page

export const WHATSAPP_URL = "https://wa.me/5514998040911?text=Ol%C3%A1%2C%20gostaria%20de%20uma%20an%C3%A1lise%20sobre%20ITBI%20pago%20a%20maior%20em%20S%C3%A3o%20Paulo";
export const TJSP_URL = "https://esaj.tjsp.jus.br/cpopg/search.do?conversationId=&cbPesquisa=NUMOAB&dadosConsulta.valorConsulta=406256&cdForo=53";
export const OAB_URL = "https://www2.oabsp.org.br/asp/consultainscritos/consulta01.asp";

export const trustItems = [
  "Análise do caso 100% gratuita",
  "Honorários somente no êxito",
  "Resposta pelo WhatsApp",
];

export const benefits = [
  {
    title: "Análise gratuita",
    description: "A avaliação inicial do seu caso é feita sem qualquer custo ou compromisso.",
    icon: "ShieldCheck",
  },
  {
    title: "Cerca de 10 meses",
    description: "Tempo médio estimado de tramitação do processo judicial até a restituição do valor devido.",
    icon: "CalendarClock",
  },
  {
    title: "Honorários de êxito",
    description: "Você só paga honorários se o processo for ganho — sem risco financeiro inicial.",
    icon: "HandCoins",
  },
];

export const reasons = [
  {
    title: "Base de cálculo",
    description: "A Justiça reconhece que o uso isolado do valor venal de referência pela Prefeitura de São Paulo é questionável.",
  },
  {
    title: "Tema 1.113 do STJ",
    description: "A tese do Superior Tribunal de Justiça é vinculante e oferece segurança jurídica para discutir a cobrança.",
  },
  {
    title: "Restituição do indébito",
    description: "É possível pedir a devolução da diferença paga a maior, com correção monetária desde o recolhimento.",
  },
];

export const stjPoints = [
  "O valor declarado pelo contribuinte presume-se verdadeiro",
  "O Município não pode arbitrar automaticamente outro valor",
  "A cobrança maior pode ser questionada judicialmente",
  "O contribuinte pode pedir a restituição do valor pago indevidamente",
];

export const steps = [
  {
    number: "01",
    title: "Análise documental",
    description: "Avaliamos a guia de ITBI, escritura e valor real da transação para apurar o valor exato a recuperar.",
  },
  {
    number: "02",
    title: "Ação judicial",
    description: "Ingressamos com a ação de repetição de indébito. Tramitação média de cerca de 10 meses.",
  },
  {
    number: "03",
    title: "Honorários somente no êxito",
    description: "Você não paga honorários iniciais — eles incidem apenas em caso de êxito no processo.",
  },
];

export const transparencyCards = [
  {
    label: "Mais de 50 processos ativos na capital",
    title: "Veja nossos processos de ITBI no TJSP",
    description: "Acesse a consulta pública do Tribunal de Justiça de São Paulo e visualize, neste exato momento, todos os processos de restituição de ITBI conduzidos pelo escritório na capital — vinculados diretamente à OAB nº 406.256.",
    cta: "Ver processos no e-SAJ TJSP",
    url: TJSP_URL,
    icon: "FileSearch",
  },
  {
    label: "Registro profissional",
    title: "Verifique a inscrição na OAB/SP",
    description: "Confirme a regularidade da inscrição do Dr. Thiago Alves Pires diretamente no site oficial da Ordem dos Advogados do Brasil — Seção São Paulo, sob o nº 406.256.",
    cta: "Consultar OAB nº 406.256",
    url: OAB_URL,
    icon: "UserCheck",
  },
];

export const faqs = [
  {
    question: "Todo pagamento de ITBI gera direito à restituição?",
    answer: "Não. É necessário verificar se o imposto foi calculado sobre base superior à devida e se houve cobrança sem procedimento administrativo adequado.",
  },
  {
    question: "Preciso ter comprado imóvel recentemente?",
    answer: "A data do pagamento é importante para análise do prazo prescricional, em regra de até 5 anos. Cada caso deve ser avaliado individualmente.",
  },
  {
    question: "Posso pedir restituição mesmo já tendo registrado o imóvel?",
    answer: "Sim, o registro do imóvel não impede a discussão sobre eventual pagamento indevido do ITBI.",
  },
  {
    question: "A ação é contra quem?",
    answer: "Em regra, contra o Município de São Paulo, quando a cobrança do ITBI tiver sido feita de forma indevida.",
  },
];
